import './styles/index.less';
import NormalLogin from './NormalLogin';

export default NormalLogin;
